import apiClient from "../config/apiClient";

export const generateBulkPaymentUrl = async (transactionIds, patientId) => {
    const user = window.localStorage.getItem("token");
    const token = user;
    const urlSuccess = `${window.location.origin}/dshboard/payments/success`;
    const urlFail = `${window.location.origin}/dshboard/payments/failed`;
    return await apiClient.put(`/public/portal?url=transactions/paystack/init-bulk`,
      {
        patientId,
        urlSuccess,
        urlFail,
        transactionIds,
      },
      {
        headers: {
          Authorization: "Bearer " + token,
        },
      }
    );
  };
